import { FormControlLabelProps } from '@mui/material/FormControlLabel';
import { Controller, useFormContext } from 'react-hook-form';
import { PFormCheckbox } from '@/components/atoms/FormCheckbox/PFormCheckbox';
import { PInputState } from '@/components/atoms/inputState';
import { PTypography } from '@/components/atoms/Typography/PTypography';

type RHFCheckboxProps = {
  name: string;
  label: string;
  sx?: FormControlLabelProps['sx'];
  isRequired?: boolean;
  state?: PInputState;
  onValueChange?: (value: boolean) => void;
};

export default function RHFCheckbox({ name, label, sx, isRequired, state, onValueChange }: RHFCheckboxProps) {
  const { control } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      defaultValue={false}
      render={({ field: { ref, onChange, ...field }, fieldState: { error } }) => (
        <>
          <PFormCheckbox
            key={name}
            state={state}
            required={isRequired}
            checked={field.value}
            inputRef={ref}
            onChange={(e) => {
              onChange(e.target.checked);
              onValueChange?.(Boolean(e.target.checked));
            }}
            sx={sx}
            label={label}
            {...field}
          />
          {error ? (
            <PTypography variant="caption" color={'error'}>
              {error.message}
            </PTypography>
          ) : null}
        </>
      )}
    />
  );
}
